import { createFileRoute } from '@tanstack/react-router';
import { ReleaseNotesAdminPage } from '@/features/help-center/release-notes/admin/ReleaseNotesAdminPage';

export const Route = createFileRoute('/admin/help-center/release-notes')({
  component: ReleaseNotesAdminPage,
});
